import React from "react";
import PatientCard from "../../Patient/partial/PatientCard";
import TimeAgo from "react-timeago";
import { cleanDate } from "../../../util/app";

const YourAppointmentList = ({ items = [], onAttend }) => {
    if (items.length < 1)
        return (
            <div className="text-center text-pink">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong>No Appointment has been added yet</strong>
            </div>
        );
    return (
        <table className="table table-bordered table-hover">
            <thead>
                <tr className="text-left">
                    <th className="text-center">SN</th>
                    <th> Patient </th>
                    <th> Department</th>
                    <th>Time Ago</th>
                    <th> Date </th>
                    <th> Note </th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {items.map((item, index) => {
                    return (
                        <tr key={index}>
                            <td className="inbox-small-cells text-center">{index + 1}</td>

                            <td className="view-message">
                                <PatientCard item={item.patient} />
                            </td>

                            <td className="view-message">
                                {item.department.name}
                                <br />
                                {item.attended ? <span className="label label-sm label-success">Attended</span> : <span className="label label-sm label-danger">Unattended</span>}
                            </td>
                            <td>
                                <span className="badge badge-primary">
                                    <TimeAgo date={new Date(parseInt(item.date))} />
                                </span>
                            </td>
                            <td className="view-message">
                                <span>{cleanDate(parseInt(item.date), true, false)}</span>
                            </td>
                            <td>{item.note}</td>
                            <td className="view-message text-center">
                                {!item.attended && (
                                    <>
                                        <button onClick={() => onAttend(item)} title="Attend" className="btn btn-tbl-edit btn-xs btn-success">
                                            <i className="fa fa-check"></i>
                                        </button>
                                    </>
                                )}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default YourAppointmentList;
